var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportsEo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12996_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.26953 4.42969V4.40234L10.2539 2.98047L12.9609 3.39062C13.5898 4.40234 13.9453 5.55078 14 6.75391L12.0039 8.47656L10.3359 7.76562L9.26953 4.42969ZM7.30078 10.418L10.1445 8.33984L11.7578 9.05078L12.0039 11.9492C11.375 12.6055 10.6367 13.0977 9.81641 13.4531L7.30078 12.2227V10.418ZM4.26562 2.625L5.52344 0.21875C6.48047 0 7.51953 0 8.47656 0.21875L9.73438 2.625L8.75 4.04688H5.27734L4.26562 2.625ZM12.3867 8.96875L13.9727 7.57422C13.8906 8.94141 13.3984 10.1992 12.5781 11.293L12.3867 8.96875ZM1.53125 2.70703C2.35156 1.64062 3.44531 0.875 4.73047 0.4375L3.69141 2.37891L1.53125 2.70703ZM0 6.75391C0.0546875 5.55078 0.410156 4.40234 1.03906 3.39062L3.74609 2.98047L4.75781 4.40234L3.66406 7.76562L1.99609 8.47656L0 6.75391ZM1.99609 11.9492L2.24219 9.05078L3.85547 8.33984L6.69922 10.418V12.2227L4.18359 13.4531C3.36328 13.0977 2.625 12.5781 1.99609 11.9492ZM0.0273438 7.57422L1.61328 8.96875L1.42188 11.293C0.601562 10.1992 0.109375 8.94141 0.0273438 7.57422ZM4.97656 13.7539L7 12.7695L9.02344 13.7539C8.36719 13.9453 7.68359 14.0547 7 14.0547C6.31641 14.0547 5.63281 13.9453 4.97656 13.7539ZM4.26562 7.90234L5.30469 4.67578H8.69531L9.73438 7.90234L7 9.87109L4.26562 7.90234ZM12.4688 2.70703C11.6484 1.64062 10.5547 0.875 9.26953 0.4375L10.3086 2.37891L12.4688 2.70703Z",
    fill: "black",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12996_171",
    x: 0,
    y: 0,
    width: 14,
    height: 15.0547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12996_171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12996_171",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsEo);
export default ForwardRef;